import type { UserTag } from "services/users/model";
import { LocalStorageKeys } from "utils/storage";

type RecentTag = Pick<UserTag, "id" | "name">;

// TODO should we ask server to return 'popular' tags instead?
const RECENT_TAGS_NUMBER_OF_ITEMS = 5;

export function addItemToRecentTags(item: RecentTag) {
  let recentTags = getRecentTags();

  const itemIndex = recentTags.findIndex(tag => tag.id === item.id);
  if (itemIndex > -1) {
    // If the item is already in recent tags, then just move the item to the top.
    // Note that `splice` has the following syntax splice(index, howmany, el1, /*...,*/ elN), where
    // - `index` is the position in the array you want to start removing elements from,
    // - `howmany` is how many elements you want to remove from index,
    // - `el1`, ..., `elN` are elements you want to insert from position index.
    // It also returns removed elements.
    recentTags.splice(0, 0, recentTags.splice(itemIndex, 1)[0]);
  } else {
    if (recentTags.length > RECENT_TAGS_NUMBER_OF_ITEMS - 1) {
      recentTags = recentTags.slice(0, RECENT_TAGS_NUMBER_OF_ITEMS - 1);
    }
    recentTags.unshift({
      id: item.id,
      name: item.name,
    });
  }

  localStorage.setItem(LocalStorageKeys.recentTags, JSON.stringify(recentTags));
  return recentTags;
}

export function getRecentTags() {
  const recentTags = localStorage.getItem(LocalStorageKeys.recentTags);
  return recentTags ? (JSON.parse(recentTags) as RecentTag[]) : [];
}

export const TagCategories = {
  level: "level",
  skills: "teaching_skills",
  job: "job_category",
  management: "management_level",
  industry: "industry",
} as const;

export function findSelectedTagIdByCategory(
  tags: UserTag[] | undefined,
  categoryName: string
) {
  return tags?.find(({ category }) => category === categoryName)?.id;
}

export function getTagsByCategory(tags: UserTag[] | undefined, searchCategory: string) {
  return (tags ?? [])
    .filter(({ category }) => category === searchCategory)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
}
